// App.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
// import WheelPage from "./components/WheelPage";
import WheelWrapper from "./components/WheelWrapper";
import AdminWrapper from "./components/AdminWrapper";
import LoginPage from "./components/LoginPage";
import DashbordPage from "./components/DashbordPage";
import ValidatePage from "./components/validatePage";
import AdvertisPage from "./components/advertisPage";
import Tickethistory from "./components/tickethistoryPage";
import ReportsPage from "./components/reports/ReportsPage";
// import ReportsWrapper from "./components/reports/ReportsWrapper";
import ProfiSharePage from "./components/profit-share-report/ProfitSharePage";
import BettingShop from "./components/betting-shop/BettingShop";
import UserManagement from "./components/user-management/UserManagement";
import ShiftManagement from "./components/shift-management/ShiftManagement";
import ShiftHistory from "./components/shift-history/ShiftHistory";
import ShiftReview from "./components/shift-review/ShiftReview";
import ShiftCheckout from "./components/shift-checkout/ShiftCheckout";
import axios from 'axios';
import { API_URL } from './components/environment';

import "./styles.css";
import "./components/shift-history/LoadingSpinner.css";


// =====================
// LoadingContext
// =====================
const LoadingContext = createContext();
export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (context === undefined) {
    throw new Error("useLoading must be used within LoadingProvider");
  }
  return context;
};
const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading, showModal, setShowModal }}>
      {children}
    </LoadingContext.Provider>
  );
};

// =====================
// Loader component
// =====================
const Loader = () => (
  <div className="loading-spinner-one">
    <div className="spin1-border">

      <div className="spin1-number">
        <div className="spin1-number__text">
          <span className="spin1-number__text-big">LOADING...</span>
        </div>
      </div>

    </div>
  </div>
);
// =====================
// Modal component
// =====================

const ModalPopup = () => {
  const { showModal, setShowModal } = useLoading();

  if (!showModal) return null;

  return (
    <div className="modal-overlay" onClick={() => setShowModal(false)}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <h2>New shift added for review</h2>
        {/* <p>New shift added for review</p> */}
        <div className="notif-modal-btn-wrap">
          <button onClick={() => setShowModal(false)}>Close</button>
        </div>
      </div>
    </div>
  );
};
// =====================
// RouteChangeLoader (2s delay)
// =====================
const RouteChangeLoader = () => {
  const location = useLocation();
  const { setIsLoading } = useLoading();

  useEffect(() => {
    setIsLoading(true);
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 300);
    return () => clearTimeout(timeout);
  }, [location]);

  return null;
};

// =====================
// PrivateRoute
// =====================
const PrivateRoute = ({ element }) => {
  const { user } = useAuth();
  return user ? element : <Navigate to="/login" replace />;
};

// =====================
// Main App Component
// =====================
function App() {
  return (
    <AuthProvider>
      <LoadingProvider>
        <Router>
          <AppContent />
        </Router>
      </LoadingProvider>
    </AuthProvider>
  );
}

function AppContent() {
  const { isLoading, setShowModal } = useLoading();

  useEffect(() => {
    // run this for auditor and cashier roles
    const poller = setInterval(async () => {
      // check current user and current role in local storage
      const role = localStorage.getItem("sun_userRole");
      const isAuditor = role === 'AUDITOR';
      const userId = localStorage.getItem("sun_userId") || '';
      if (isAuditor && userId) {
        try {
          const response = await axios.post(API_URL + "/check-auditor-notif", {
            agentId: userId,
          });
          if (response.data && response.data.hasNotification === "yes") {
            setShowModal(true);
          } else {
            setShowModal(false);
          }
        } catch (err) {
          console.error("API poll failed:", err);
        }
      }

      // track betting shop online
      // condition for betting shop
      const isCashier = role === 'CASHIER';
      if (isCashier && userId) {
        // update online status for betting shop by id, get from local storage
        const storedShopId = localStorage.getItem('sun_bettingShopId') || '';
        try {
          await axios.put(API_URL + "/betshlastactivity", {
            bettingShopId: storedShopId,
          });

        } catch (err) {
          console.error("Lastatcivity API call failed:", err);
        }
      }

      // last activity for all users
      if (userId) {
        try {
          await axios.put(API_URL + "/userlastactivity", {
            agentId: userId,
          });
        } catch (err) {
          console.error("Lastatcivity API call failed:", err);
        }
      }

    }, 15000);
  
    return () => clearInterval(poller);
  }, []);

  return (
    <>
      {isLoading && <Loader />}
      <ModalPopup /> {/* Global Modal */}
      <RouteChangeLoader />
      <Routes>
          <Route path="/" element={<WheelWrapper />} />
          <Route path="/login" element={<LoginPage />} />

          {/* <Route path="/dashboard" element={<DashbordPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/validate" element={<ValidatePage />} />
          <Route path="/advertis" element={<AdvertisPage />} />
          <Route path="/tickethistory" element={<Tickethistory />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/betting-shop" element={<BettingShop />} />
          <Route path="/user-management" element={<UserManagement />} />
          <Route path="/shift-management" element={<ShiftManagement />} /> */}
          {/* ✅ Protected Routes */}
          <Route path="/dashboard" element={<PrivateRoute element={<DashbordPage />} />} />
          <Route path="/admin" element={<PrivateRoute element={<AdminWrapper />} />} />
          <Route path="/validate" element={<PrivateRoute element={<ValidatePage />} />} />
          <Route path="/advertis" element={<PrivateRoute element={<AdvertisPage />} />} />
          <Route path="/tickethistory" element={<PrivateRoute element={<Tickethistory />} />} />
          <Route path="/reports" element={<PrivateRoute element={<ReportsPage />} />} />
          <Route path="/profitshare-report" element={<PrivateRoute element={<ProfiSharePage />} />} />
          <Route path="/betting-shop" element={<PrivateRoute element={<BettingShop />} />} />
          <Route path="/user-management" element={<PrivateRoute element={<UserManagement />} />} />
          <Route path="/shift-management" element={<PrivateRoute element={<ShiftManagement />} />} />
          <Route path="/shift-history" element={<PrivateRoute element={<ShiftHistory />} />} />
          <Route path="/shift-review" element={<PrivateRoute element={<ShiftReview />} />} />
          <Route path="/shift-checkout/:shiftId?" element={<PrivateRoute element={<ShiftCheckout />} />} />


          

          {/* <Route path="/wheel" element={<WheelTest />} /> */}
      </Routes>
    </>
  );
}

export default App;
